

// write a Promise to wait ms

function wait(ms) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
};


export { wait };

